/**
 * @ngdoc object
 * @name queue
 * @description
 *
 */
angular
    .module('festzelt-os.queue', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./queue-routes');

// Controllers
require('./controllers/list-controller');

// Factories
require('./factories/job-log-factory');

// Stores
require('./store/jobs-log');



// WEBPACK FOOTER //
// ./src/app/pages/queue/queue-module.js